import React, { useState, useEffect } from 'react';
import { TrashIcon } from '@heroicons/react/24/outline';
import { LuPlus } from "react-icons/lu";
import { createMetrial, createProcess, deleteMetrialId, DeleteProcessId, getAllMetrials, getallProcess } from '../../../api/api';
import toast from 'react-hot-toast';
import { v4 as uuidv4 } from 'uuid'; // for unique IDs
import {generateRandomObjectId} from '../../../utils'
const Metrials = () => {
  const [processOptions, setProcessOptions] = useState([]);
  const [newProcessName, setNewProcessName] = useState('');
  const [loading, setLoading] = useState(false);
 
  // Fetch all processes on component mount
  useEffect(() => {
    const fetchProcesses = async () => {
      setLoading(true);
      try {
        const data = await getAllMetrials();
        setProcessOptions(data.data);
      } catch (error) {
        toast.error('Failed to fetch processes');
      } finally {
        setLoading(false);
      }
    };

    fetchProcesses();
  }, []);

 
   
  const addNewProcess = () => {

    const newProcess = {
      _id: generateRandomObjectId(), 
      name: newProcessName,
    };

    setProcessOptions((prevOptions) => [...prevOptions, newProcess]);
    setNewProcessName(''); // Clear input after adding
  };

  // Handle updating process names
  const handleProcessNameChange = (id, name) => {
    setProcessOptions((prevOptions) =>
      prevOptions.map((process) =>
        process._id === id ? { ...process, name } : process
      )
    );
  };

  // Handle deleting a process
  const handleDeleteProcess = async (id) => {
    setProcessOptions((prevOptions) => prevOptions.filter((process) => process._id !== id));
    try {
      const res = await deleteMetrialId(id);
      toast.success(res.message);
    } catch (error) {
      toast.error('Failed to delete process');
    }
  };

  // Handle submitting the process options
  const handleSubmit = async () => {
    try {
      const data = await createMetrial({ metrials: processOptions });
      toast.success(data.message);
    } catch (error) {
      toast.error("Failed to create process");
    }
  };

  return (
    <div className="p-4 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-6">Metrials</h1>

      {loading ? (
        <p>Loading Metrials...</p>
      ) : (
        <div className="flex w-full lg:w-6/6 xl:w-4/4 mx-auto">
          <div className="grid grid-cols-3 gap-4 w-full">
            {processOptions.map((processOption, index) => (
              <div key={processOption._id} className="relative flex flex-col w-full">
                <label htmlFor={`process-${processOption._id}`} className="block mb-1 text-sm font-medium text-gray-700">
                  Metrial Name
                </label>
                <input
                  id={`metrials-${processOption._id}`}
                  type="text"
                  value={processOption.name}
                  onChange={(e) => handleProcessNameChange(processOption._id, e.target.value)}
                  className="w-full px-3 py-2 border rounded-md focus:ring focus:ring-black focus:ring-opacity-50"
                />
                {index > 2 && (
                  <button
                    onClick={() => handleDeleteProcess(processOption._id)}
                    className="absolute top-0 right-0 p-1 text-gray-900 hover:text-gray-700"
                  >
                    <TrashIcon className="w-4 h-4" />
                  </button>
                )}
              </div>
            ))}
          </div>

          {/* Add New Process Button */}
          <div className="relative flex flex-col w-1/6 justify-start ml-4 p-3">
            <button
              onClick={addNewProcess}
              className="mt-2 flex items-center justify-center border-2 border-dashed border-gray-300 rounded-full w-12 h-12 text-gray-500 hover:text-gray-700 hover:border-gray-400 transition-colors duration-200"
            >
              <LuPlus className="w-6 h-6" />
            </button>
          </div>
        </div>
      )}

      {/* Submit Button */}
      <div className="col-span-3 text-center mt-6">
        <button
          type="submit"
          onClick={handleSubmit}
          className="w-full py-3 px-4 bg-black text-white font-semibold rounded-md shadow focus:ring focus:ring-opacity-75 focus:ring-black"
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default Metrials;
